import { FC } from "react"

const DrawerCloseIcon: FC = () => {
    return (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_968_42844)">
                <circle cx="30" cy="28" r="20" fill="white" />
                <rect x="36.1465" y="33.4997" width="1.17647" height="16.4706" transform="rotate(135 36.1465 33.4997)" fill="black" />
                <rect x="35.5" y="21.8534" width="1.17647" height="16.4706" transform="rotate(45 35.5 21.8534)" fill="black" />
            </g>
            <defs>
                <filter id="filter0_d_968_42844" x="0" y="0" width="60" height="60" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_968_42844" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_968_42844" result="shape" />
                </filter>
            </defs>
        </svg>
    )
}

export default DrawerCloseIcon